import React from 'react'
import { SimpleGrid, Box, Text } from '@chakra-ui/react'
import RaffleCard, { combinedRaffleType } from '../../dApp/components/RaffleCard'
import RaffleCardListSkeleton from '../../dApp/components/Skeletons/RaffleCardListSkeleton'

const RewardRaffleList: React.FC<{
  rewardRaffles?: combinedRaffleType[]
  isLoading: boolean
  userId?: string
}> = ({ rewardRaffles, isLoading, userId }) => {
  return (
    <>
      <SimpleGrid w='100%' columns={[1, 2, 3, 4]} spacing={[6, 8]}>
        {rewardRaffles && rewardRaffles?.map((r) => {
          return <RaffleCard key={r.id} raffle={r} userId={userId}></RaffleCard>
        })}
      </SimpleGrid>

      {isLoading && (
        <Box w='100%'>
          <RaffleCardListSkeleton />
        </Box>
      )}

      {rewardRaffles?.length == 0 && (
        <Text>No rewards are currently live.</Text>
      )}
    </>
  )
}

export default RewardRaffleList